const URLS = {
	development: {
		logger: 'http://localhost:82',
		manager: 'http://localhost',
		sequencer: 'http://localhost:81',
		media: 'https://content.imaginelearning.com',
		studentdata: 'http://localhost:83',
		portal: 'http://localhost:50000',
		client: 'http://localhost:84/api/version',
		support: 'https://support.imaginelearning.com',
		kvs: 'https://testapi.imaginelearning.com',
		auth: 'http://localhost:5000',
		authEdge: 'https://app.dev.edgenuityapp.com/api',
		authEdge2: 'https://identity-qa.imaginelearning.com/api',
		productSelection: 'http://localhost:5001/productSelection',
		signoutPage: 'http://localhost:5001/signout',
		signin: 'http://localhost:5000/signin',
		product: 'http://localhost:3000'
	},
	test: {
		logger: 'https://testapi.imaginelearning.com',
		manager: 'https://testmanager.my.imaginelearning.com',
		sequencer: 'https://testsequencer.my.imaginelearning.com',
		media: 'https://content.imaginelearning.com',
		studentdata: 'https://testapi.imaginelearning.com',
		portal: 'https://test.my.imaginelearning.com',
		client: 'https://testapi.imaginelearning.com',
		support: 'https://support.imaginelearning.com',
		kvs: 'https://testapi.imaginelearning.com',
		auth: 'https://testapi.imaginelearning.com',
		authEdge: 'https://identity.qa.edgenuityapp.com/api',
		authEdge2: 'https://identity-qa.imaginelearning.com/api',
		signin: 'https://testlogin.imaginelearning.com/signin',
		signoutPage: 'http://testapi.imaginelearning.com/signout',
		productSelection: 'https://testlogin.imaginelearning.com/productSelection',
		product: 'https://testapp.imaginelearning.com'
	},
	load: {
		logger: 'https://api.imaginelearning.com',
		manager: 'https://loadmanager.my.imaginelearning.com',
		sequencer: 'https://loadsequencer.my.imaginelearning.com',
		media: 'https://content.imaginelearning.com',
		studentdata: 'https://loadstudentdata.my.imaginelearning.com',
		portal: 'https://load.my.imaginelearning.com',
		client: 'https://clientapi.my.imaginelearning.com',
		support: 'https://support.imaginelearning.com',
		kvs: 'https://testapi.imaginelearning.com',
		auth: 'https://testapi.imaginelearning.com',
		authEdge: 'https://identity.qa.edgenuityapp.com/api',
		authEdge2: 'https://identity-qa.imaginelearning.com/api',
		signin: 'https://testlogin.imaginelearning.com/signin',
		signoutPage: 'http://testapi.imaginelearning.com/signout',
		productSelection: 'https://testlogin.imaginelearning.com/productSelection',
		product: 'https://testapp.imaginelearning.com'
	},
	rc: {
		logger: 'https://rcapi.imaginelearning.com',
		manager: 'https://rcmanager.my.imaginelearning.com',
		sequencer: 'https://rcsequencer.my.imaginelearning.com',
		media: 'https://content.imaginelearning.com',
		studentdata: 'https://rcapi.imaginelearning.com',
		portal: 'https://rc.my.imaginelearning.com',
		client: 'https://rcapi.my.imaginelearning.com',
		support: 'https://support.imaginelearning.com',
		kvs: 'https://rcapi.imaginelearning.com',
		auth: 'https://rcapi.imaginelearning.com',
		authEdge: 'https://identity.staging.edgenuityapp.com/api',
		authEdge2: 'https://identity-staging.imaginelearning.com/api',
		signin: 'https://rclogin.imaginelearning.com/signin',
		signoutPage: 'http://rcapi.imaginelearning.com/signout',
		productSelection: 'https://rclogin.imaginelearning.com/productSelection',
		product: 'https://rcapp.imaginelearning.com'
	},
	demo: {
		logger: 'https://api.imaginelearning.com',
		manager: 'https://demomanager.my.imaginelearning.com',
		sequencer: 'https://demosequencer.my.imaginelearning.com',
		media: 'https://content.imaginelearning.com',
		studentdata: 'https://demostudentdata.my.imaginelearning.com',
		portal: 'https://demo.my.imaginelearning.com',
		client: 'https://clientapi.my.imaginelearning.com',
		support: 'https://support.imaginelearning.com',
		kvs: 'https://testapi.imaginelearning.com',
		auth: 'https://testapi.imaginelearning.com',
		authEdge: 'https://identity.qa.edgenuityapp.com/api',
		authEdge2: 'https://identity-qa.imaginelearning.com/api',
		signin: 'https://testlogin.imaginelearning.com/signin',
		signoutPage: 'http://testapi.imaginelearning.com/signout',
		productSelection: 'https://testlogin.imaginelearning.com/productSelection',
		product: 'https://testapp.imaginelearning.com'
	},
	production: {
		logger: 'https://api.imaginelearning.com',
		manager: 'https://manager.my.imaginelearning.com',
		sequencer: 'https://sequencer.my.imaginelearning.com',
		media: 'https://content.imaginelearning.com',
		studentdata: 'https://api.imaginelearning.com',
		portal: 'https://my.imaginelearning.com',
		client: 'https://api.imaginelearning.com',
		support: 'https://support.imaginelearning.com',
		kvs: 'https://api.imaginelearning.com',
		auth: 'https://api.imaginelearning.com',
		authEdge: 'https://identity.app.edgenuity.com/api',
		authEdge2: 'https://identity.imaginelearning.com/api',
		signin: 'https://login.imaginelearning.com/signin',
		signoutPage: 'http://api.imaginelearning.com/signout',
		productSelection: 'https://login.imaginelearning.com/productSelection',
		product: 'https://app.imaginelearning.com'
	}
};

export default URLS;

export const LEGACY_APP = 'https://go.imaginelearning.com';

export const VERSIONS = {
	development: {
		manager: 'vLatest'
	},
	test: {
		manager: 'v2.1'
	},
	load: {
		manager: 'v2.0'
	},
	rc: {
		manager: 'v2.0'
	},
	demo: {
		manager: 'v2.0'
	},
	production: {
		manager: 'v2.0'
	}
};



// WEBPACK FOOTER //
// ./src/constants/urls.js